import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { Breadcrumbs, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { getDomainInfo } from "../../utils/utils";
import { inactivePathNamesForBreadCrumbs } from "../../config";


const BreadCrums = () => {
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter((x) => x);
    const { userId } = useParams();
    const { isPredefinedDomain, uid } = getDomainInfo(userId);
    // console.log(pathnames,'pathnames')
    const truncate = (text, maxLength = 18) => {
        return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
    };

    return (
        <div className="breadcrumbs-container">
            <div className=" container">
                <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                >
                    <Typography
                        color="textPrimary"
                        style={{ cursor: "pointer" }}
                    >
                        <Link to={isPredefinedDomain ? `/${uid}` : '/'}>HOME</Link>
                    </Typography>
                    {pathnames.slice(1, pathnames.length - 1).map((value, index) => {
                        const to = `/${pathnames.slice(1, index + 1).join("/")}`; // Skip the first path
                        return (
                            <Typography
                                color="textPrimary"
                                style={{ cursor: "pointer" }}
                            >
                                {inactivePathNamesForBreadCrumbs.includes(value) ?
                                    value.charAt(0).toUpperCase() + value.slice(1)?.split("_").join(" ") : (
                                        <Link to={to}>
                                            {value.charAt(0).toUpperCase() + value.slice(1)?.split("_").join(" ")}
                                        </Link>
                                    )}
                            </Typography>
                        );
                    })}

                    <Typography
                        color="textPrimary"
                        style={{ cursor: "pointer" }}
                    >
                        {truncate(decodeURIComponent(pathnames[pathnames.length - 1])?.split("|")[0]?.replaceAll('_', " "))}
                    </Typography>
                </Breadcrumbs>
            </div>
        </div>
    );
};

export default BreadCrums